import React, { useState } from 'react';
import { Container, Card, CardBody, Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faEye, faTimes, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import amb1 from "./../../assets/Canteen/Ambala/1.jpg";
import bhi1 from "./../../assets/Canteen/Bhiwani/1.jpeg";
import bhi2 from "./../../assets/Canteen/Bhiwani/2.jpeg";
import cd1 from "./../../assets/Canteen/Charkhi Dadri/1.jpeg";
import cd2 from "./../../assets/Canteen/Charkhi Dadri/2.jpeg";
import fa1 from "./../../assets/Canteen/Fatehabad/1.jpg";
import ga1 from "./../../assets/Canteen/Gurugram/1.jpeg";
import ji1 from "./../../assets/Canteen/Jind/1.jpeg";
import ji2 from "./../../assets/Canteen/Jind/2.jpg";
import ku1 from "./../../assets/Canteen/Kurukshetra/1.JPG";
import pa1 from "./../../assets/Canteen/Palwal/1.jpeg";
import pn1 from "./../../assets/Canteen/Panipat/1.JPG";
import canteen from "./../../assets/Army_Canteen_Map_Haryana_without_BM_page-0001.jpg";

const data=[
  { location: 'Ambala', address: 'Golden Lion ESM Canteen, Ambala Cantt.-134003', images: [amb1] },
  { location: 'Bhiwani', address: 'ESM Canteen, Near Bhiwani Jn Station, Bhiwani-127021', images: [bhi1,bhi2] },
  { location: 'Charkhi Dadri', address: 'ESM Canteen, Ghikadha Road, Near Tejab Factory, Charkhi Dadri - 127306', images: [cd1,cd2] },
  { location: 'Fatehabad', address: 'ESM Canteen, District Sainik & Ardh Sainik Welfare Office, C-2 Building, Old Judicial Complex, Fatehabad – 125050', images: [fa1] },
  { location: 'Gurugram', address: 'ESM Canteen, Army Cantt Area, Rao Gajraj Singh Marg, Sector-18, Dundahera, Gurugram-122016', images: [ga1] },
  { location: 'Jind', address: 'ESM Canteen, Gohana Road, Near DRDA Building, District Sainik & Ardh Sainik Welfare Office, Jind -126102 [Tele: 01681-298760]', images: [ji1,ji2] },
  { location: 'Kurukshetra', address: 'Golden Lion ESM Canteen, Pipli Ladwa Road, Near RBL Bank, Pipli Thanesar, Kurukshetra-136131', images: [ku1] },
  { location: 'Palwal', address: 'ESM Canteen, Kalyan Enclave Nangla, Lakhi Singh Palwal, Palwal – 121102 [Mob-9671668456]', images: [pa1] },
  { location: 'Panipat', address: 'ESM Canteen, Near Seewah Bus Stand, Chautala Road, Seewah, Panipat - 132103', images: [pn1] },
  { location: 'Hisar', address: 'Dot Canteen, Gate No. – 2, Hisar Cantt – 125006', images: [] },
  { location: 'Karnal', address: 'Golden Lion ESM Canteen, District Sainik & Ardh Sainik Welfare Office, Karnal – 132002', images: [] },
  { location: 'Kaithal', address: 'Golden Lion ESM Canteen, Amargarh Colony, Near SBI Main Branch, Kaithal – 136027', images: [] },
  { location: 'Sonipat', address: 'ESM Canteen, Jatwara, Jahri Road, Near Sugar Mill, Sonipat-131001', images: [] },
  { location: 'Faridabad', address: 'ESM Canteen, Sector-16, Faridabad-121002 [Tele-0129-2261166]', images: [] },
  { location: 'Jhajjar', address: 'ESM Canteen, Gwalison-Chuchukwas Road, Near Railway Station, Jhajjar-124103', images: [] },
  { location: 'Panchkula', address: 'URC, Western Command, Chandimandir Cantonment, Panchkula – 134109', images: [] },
  { location: 'Rohtak', address: 'Chinkara CSD Canteen, Model Town Rohtak, Delhi Road, Rohtak – 124001', images: [] },
  { location: 'Sirsa', address: 'URC, Air Force Station Sirsa, Dabwali Road, Sirsa-125055', images: [] },
  { location: 'Rewari', address: '(i) ESM Canteen, Mahendargarh Road, Near Gopal Dev Chowk, Rewari-123401 (ii) Chinkara ESM Canteen, SDM Office & Tehsil, Kosli - 123302', images: [] },
  { location: 'Mahendergarh', address: '(i) ESM Canteen, Sainik & Ardh Sainik Welfare Office, Near Brahamdev Chowk, ITI Road, Mahendergarh-123029 [Tele: 01285-220869 / Mob: 8650422416] <br/>(ii) ESM Canteen, Sainik & Ardh Sainik Welfare Office, (In front of PWD Rest House) Narnaul-123001 [Tele: 01282-251763] <br/>(iii) ESM Canteen, Near Vikas Marriage Palace, Sahore Road, Kanina-123027 [Tele: 01285-235111]', images: [] },
  { location: 'Yamuna Nagar', address: 'Golden Lion ESM Canteen, Ambala Road, Near Capital Hospital, Jagadhri-135003', images: [] }
]

const CanteenStores = () => {
  const [modalShow, setModalShow] = useState(false);
  const [selectedCanteen, setSelectedCanteen] = useState(null);
    
  const handleShowModal = (canteen) => {
    setSelectedCanteen(canteen);
    setModalShow(true);
  };
    
  const handleCloseModal = () => {
    setModalShow(false);
    setSelectedCanteen(null);
  };
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faStore} className="me-2" />
            Canteen Stores
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faStore} className="me-2" />
              Canteen Store Directory
            </h4>
          </div>
          <CardBody className="p-4">
            <div className="table-responsive">
              <Table bordered hover className="mb-0">
                <thead>
                  <tr>
                    <th style={{ background: '#1e3c72', color: 'white', width: '8%' }}>S.No.</th>
                    <th style={{ background: '#1e3c72', color: 'white', width: '15%' }}>District</th>
                    <th style={{ background: '#1e3c72', color: 'white', width: '57%' }}>Address</th>
                    <th style={{ background: '#1e3c72', color: 'white', width: '20%' }}>Images</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td style={{ color: '#495057' }}>{index + 1}</td>
                      <td style={{ color: '#1e3c72', fontWeight: '600' }}>{item.location}</td>
                      <td style={{ color: '#495057', wordWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'normal' }} dangerouslySetInnerHTML={{ __html: item.address }}></td>
                      <td className="text-center">
                        {item.images.length !== 0 ? (
                          <Button 
                            style={{
                              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                              border: 'none',
                              borderRadius: '20px',
                              padding: '6px 15px',
                              fontSize: '14px',
                              fontWeight: '600',
                               width: window.innerWidth < 768 ? '100%' : '40%'
                            }}
                            onClick={() => handleShowModal(item)}
                            onMouseOver={(e) => {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)';
                              e.currentTarget.style.transform = 'scale(1.05)';
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                              e.currentTarget.style.transform = 'scale(1)';
                            }}
                          >
                            <FontAwesomeIcon icon={faEye} className="me-2" />
                            View
                          </Button>
                        ) : (
                          <span style={{ color: '#6c757d' }}>-</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>

        <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faStore} className="me-2" />
              Canteen Map
            </h4>
          </div>
          <CardBody className="p-4">
            <img src={canteen} style={{width: "100%"}} alt="Canteen Map" />
          </CardBody>
        </Card>

        <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
          <div style={{
            background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
            padding: '25px',
            color: 'white'
          }}>
            <h4 className="fw-bold mb-0">
              <FontAwesomeIcon icon={faShoppingCart} className="me-2" />
              View Our Inventory
            </h4>
          </div>
          <CardBody className="p-5 text-center">
            <p className="mb-4" style={{ color: '#495057', fontSize: '1.1rem' }}>
              Click below to view our complete inventory and products
            </p>
            <Button
              style={{
                background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                border: 'none',
                borderRadius: '20px',
                padding: '12px 40px',
                fontWeight: '600',
                fontSize: '1rem'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)';
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <FontAwesomeIcon icon={faShoppingCart} className="me-2" />
              <a 
                href="https://csdindia.gov.in/default.aspx#" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ 
                  color: 'white', 
                  textDecoration: 'none'
                }}
              >
                Click Here
              </a>
            </Button>
          </CardBody>
        </Card>
      </Container>
        {selectedCanteen && (
          <Modal isOpen={modalShow} toggle={handleCloseModal} size="lg" centered>
            <ModalHeader 
              toggle={handleCloseModal}
              style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white',
                border: 'none'
              }}
            >
              <FontAwesomeIcon icon={faStore} className="me-2" />
              Canteen Store <span style={{color: '#fff'}}>{selectedCanteen.location}</span> Images
            </ModalHeader>
            <ModalBody className="p-0">
              <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                  {selectedCanteen.images.map((_, idx) => (
                    <button
                      key={idx}
                      type="button"
                      data-bs-target="#carouselExampleAutoplaying"
                      data-bs-slide-to={idx}
                      className={idx === 0 ? 'active' : ''}
                      style={{
                        backgroundColor: idx === 0 ? '#1e3c72' : '#6c757d',
                        border: 'none',
                        width: '12px',
                        height: '12px',
                        borderRadius: '50%',
                        margin: '0 5px'
                      }}
                      aria-current={idx === 0 ? 'true' : 'false'}
                      aria-label={`Slide ${idx + 1}`}
                    ></button>
                  ))}
                </div>
                <div className="carousel-inner">
                  {selectedCanteen.images.map((image, index) => (
                    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                      <img 
                        src={image} 
                        className="d-block mx-auto" 
                        alt={`image-${index}`} 
                        style={{
                          height: '350px',
                          width: 'auto',
                          maxWidth: '100%',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                  ))}
                </div>
                <button 
                  className="carousel-control-prev" 
                  type="button" 
                  data-bs-target="#carouselExampleAutoplaying" 
                  data-bs-slide="prev"
                  style={{ opacity: '0.8' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button 
                  className="carousel-control-next" 
                  type="button" 
                  data-bs-target="#carouselExampleAutoplaying" 
                  data-bs-slide="next"
                  style={{ opacity: '0.8' }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.backgroundColor = 'transparent';
                  }}
                >
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>
            </ModalBody>
            <ModalFooter style={{ borderTop: '1px solid #e9ecef', background: '#f8f9fa' }}>
              <Button
                style={{
                  background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                  border: 'none',
                  borderRadius: '10px',
                  padding: '10px 25px',
                  fontWeight: '600'
                }}
                onClick={handleCloseModal}
              >
                <FontAwesomeIcon icon={faTimes} className="me-2" />
                Close
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </>
    );
};

export default CanteenStores;
